import React, { useState } from 'react';
import cn from 'classnames';

import { navigate } from '@reach/router';
import { connect } from 'react-redux';

import map from 'lodash/map';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeftOutlined';
import CloseIcon from '@material-ui/icons/CloseOutlined';
import { withStyles } from '@material-ui/core/styles';

import { logout } from '../../../state/actions/user';
import getRoleLandingPage from '../../../utils/getRoleLandingPage';
import avatarImg from '../../../images/avatar.svg';
import pages from '../../resources/pages';
import SignInBtn from '../SignInBtn';
import SignUpBtn from '../SignUpBtn';
import PrimaryEntries from './components/PrimaryEntries';

const styles = () => ({
  header: {
    height: '260px',
    justifyContent: 'center',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  divider: { width: '100%' },
  listRoot: { width: '100%' },
  listItemText: {
    fontFamily: 'Raleway',
    fontSize: '18px',
    color: '#6a27e8',
    textAlign: 'center',
  },
  mobileMenuPaper: {
    width: '100%',
    backgroundColor: '#ffffff',
  },
  nestedPrimary: {
    backgroundColor: '#2a149a',
    '& $listItemText': {
      fontWeight: 'bold',
      color: '#ffffff !important',
    },
  },
  nestedSecondary: {
    paddingLeft: '40px',
  },
  inverted: {
    color: '#ffffff !important',
  },
  user: {
    backgroundColor: '#6a27e8',
    color: '#ffffff',
    width: '100%',
    height: '270px',
    padding: '24px',
  },
  detailsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '22px',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    width: '100px',
    height: '100px',
  },
  username: {
    fontFamily: 'Raleway',
    fontSize: '24px',
    color: '#ffffff',
    textAlign: 'left',
    marginBottom: '12px',
  },
  email: {
    fontFamily: 'Raleway',
    fontSize: '18px',
    textAlign: 'left',
    color: '#ffffff',
    fontWeight: 500,
    marginBottom: '12px',
  },
  profileCta: {
    backgroundColor: '#ffffff',
    color: '#6a27e8',
    border: '2px solid #6a27e8',
    textTransform: 'none',
    width: '150px',
    borderRadius: '26px',
  },
  profileCtaLabel: {
    fontFamily: 'Raleway',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  signOut: {
    marginTop: '20px',
    color: '#ffffff',
    textTransform: 'none',
    width: '100%',
  },
  signOutLabel: {
    fontFamily: 'Raleway',
    fontSize: '14px',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  closeContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    position: 'absolute',
    top: '10px',
  },
  close: {
    color: '#6a27e8',
  },
});

const MenuMobile = ({
  classes,
  open,
  userId,
  username,
  email,
  roles,
  onClose,
  onLogout,
}) => {
  const [nested, setNested] = useState(undefined);
  const [showNested, setShowNested] = useState(false);

  const showSubmenu = page => {
    setNested(page);
    setShowNested(true);
  };

  const hideSubmenu = () => {
    setShowNested(false);
    setNested(undefined);
  };

  const handleNavigation = url => {
    onClose();
    navigate(url);
  };

  const handleLogout = () => {
    onLogout();
    onClose();
  };

  return (
    <Drawer
      anchor="left"
      onClose={onClose}
      open={open}
      variant="temporary"
      classes={{
        paper: classes.mobileMenuPaper,
      }}
    >
      <Grid container>
        <Grid item xs={12} className={cn(classes.section, classes.header)}>
          <div className={classes.closeContainer}>
            <IconButton
              onClick={onClose}
              className={cn(classes.close, {
                [classes.inverted]: !isEmpty(userId),
              })}
            >
              <CloseIcon />
            </IconButton>
          </div>
          {isEmpty(userId) ? (
            <>
              <SignInBtn />
              <SignUpBtn />
            </>
          ) : (
            <div className={classes.user}>
              <div className={classes.detailsContainer}>
                <Avatar
                  alt="user-image"
                  src={avatarImg}
                  className={classes.avatar}
                />
                <div className={classes.details}>
                  <div className={classes.username}>{username}</div>
                  <div className={classes.email}>{email}</div>
                  <Button
                    variant="outlined"
                    color="primary"
                    className={classes.profileCta}
                    onClick={() => handleNavigation(getRoleLandingPage(roles))}
                    classes={{
                      label: classes.profileCtaLabel,
                    }}
                  >
                    see profile
                  </Button>
                </div>
              </div>
              <Button
                variant="outlined"
                color="primary"
                className={classes.signOut}
                onClick={handleLogout}
                classes={{
                  label: classes.signOutLabel,
                }}
              >
                Sign out
              </Button>
            </div>
          )}
        </Grid>
        <Grid item xs={12} className={classes.section}>
          {isEmpty(userId) && <Divider className={classes.divider} />}
          {!showNested && (
            <List component="div" disablePadding className={classes.listRoot}>
              <PrimaryEntries
                items={pages}
                onShowSubmenu={showSubmenu}
                onNavigate={handleNavigation}
              />
            </List>
          )}
          {showNested && !isUndefined(nested) && (
            <List component="div" disablePadding className={classes.listRoot}>
              <ListItem className={classes.nestedPrimary}>
                <KeyboardArrowLeftIcon className={classes.inverted} />
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={nested.name}
                  onClick={() => hideSubmenu()}
                />
              </ListItem>
              {map(nested.submenu, (page, index) => (
                <>
                  {isUndefined(page.submenu) ? (
                    <ListItem key={index}>
                      <ListItemText
                        classes={{
                          primary: cn(
                            classes.listItemText,
                            classes.nestedSecondary
                          ),
                        }}
                        primary={page.name}
                        onClick={() => handleNavigation(page.url)}
                      />
                    </ListItem>
                  ) : (
                    <ListItem key={index}>
                      <ListItemText
                        classes={{
                          primary: cn(
                            classes.listItemText,
                            classes.nestedSecondary
                          ),
                        }}
                        primary={page.name}
                        onClick={() => showSubmenu(page)}
                      />
                    </ListItem>
                  )}
                </>
              ))}
            </List>
          )}
        </Grid>
      </Grid>
    </Drawer>
  );
};

const getUserName = state => {
  const firstname = get(state, ['user', 'firstname'], '');
  const lastname = get(state, ['user', 'lastname'], '');

  return `${firstname} ${lastname}`;
};

const mapStateToProps = state => ({
  userId: get(state, ['user', 'userId'], ''),
  email: get(state, ['user', 'email'], ''),
  roles: get(state, ['user', 'roles'], []),
  username: getUserName(state),
});

const mapDispatchToProps = dispatch => ({
  onLogout: () => dispatch(logout()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(MenuMobile));
